<template>
  <div class="home">
    <Header/>
    <Banner
      image="hero-image@2x.jpg"
      alt=""
    />
    <MembershipFormWrap
      formName="confirm"
    >
      <template slot="title">
        Thanks for<br>choosing Nike
      </template>
      <template slot="description">
        Confirm your {{ store }} membership today.
      </template>
    </MembershipFormWrap>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src

// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import MembershipFormWrap from '@/components/MembershipFormWrap.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'confirm',
  components: {
    Header,
    Banner,
    MembershipFormWrap,
    Footer,
  },
  data() {
    return {
      store: '',
    };
  },
  created() {
    this.crmId = this.$route.params.crmId;
    const getUrl = `https://ui9x5yrom4.execute-api.ap-southeast-2.amazonaws.com/prod/customer/${this.crmId}`;

    this.axios({
      method: 'get',
      url: getUrl,
    }).then((response) => {
      console.log('success');
      this.$store.commit('setInitialData', { page: 'confirm', data: response.data });

      // this.firstName = this.$store.state.firstName;
      // // this.lastName = this.getLastname;
      // this.email = this.$route.params.email;
    }).catch((error) => {
      console.log(error);
    });
  },
};
</script>
